import { ref, reactive } from 'vue';

const globalDropdownState = reactive({
  activeDropdownId: null,
  dropdowns: new Map(),
});

export function useGlobalDropdown() {
  const registerDropdown = dropdownId => {
    globalDropdownState.dropdowns.set(dropdownId, {
      id: dropdownId,
      isOpen: false,
    });
  };

  const unregisterDropdown = dropdownId => {
    globalDropdownState.dropdowns.delete(dropdownId);
    if (globalDropdownState.activeDropdownId === dropdownId) {
      globalDropdownState.activeDropdownId = null;
    }
  };

  const openDropdown = dropdownId => {
    // Close all other dropdowns
    closeAllDropdowns();

    // Open the requested dropdown
    const dropdown = globalDropdownState.dropdowns.get(dropdownId);
    if (dropdown) {
      dropdown.isOpen = true;
      globalDropdownState.activeDropdownId = dropdownId;
    }
  };

  const closeDropdown = dropdownId => {
    const dropdown = globalDropdownState.dropdowns.get(dropdownId);
    if (dropdown) {
      dropdown.isOpen = false;
    }

    if (globalDropdownState.activeDropdownId === dropdownId) {
      globalDropdownState.activeDropdownId = null;
    }
  };

  const closeAllDropdowns = () => {
    globalDropdownState.dropdowns.forEach(dropdown => {
      dropdown.isOpen = false;
    });
    globalDropdownState.activeDropdownId = null;
  };

  const isDropdownOpen = dropdownId => {
    const dropdown = globalDropdownState.dropdowns.get(dropdownId);
    return dropdown ? dropdown.isOpen : false;
  };

  const toggleDropdown = dropdownId => {
    const dropdown = globalDropdownState.dropdowns.get(dropdownId);
    if (dropdown && dropdown.isOpen) {
      closeDropdown(dropdownId);
    } else {
      openDropdown(dropdownId);
    }
  };

  return {
    registerDropdown,
    unregisterDropdown,
    openDropdown,
    closeDropdown,
    closeAllDropdowns,
    isDropdownOpen,
    toggleDropdown,
    activeDropdownId: globalDropdownState.activeDropdownId,
  };
}
